import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SEO, Reveal, Eyebrow } from "@/components/motion";
import { JOURNEY_STEPS } from "@/data/content";

export default function HowItWorks() {
  return (
    <main data-testid="how-it-works-page">
      <SEO
        title="How It Works | Booking a Clean with HOMELARA London"
        description="From choosing your service to enjoying your clean space - how booking a professional clean with HOMELARA works, step by step."
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-32 sm:pt-44 pb-16">
        <Reveal>
          <Eyebrow>How it works</Eyebrow>
          <h1 className="mt-4 max-w-3xl font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">
            Simple, from first click to fresh sheets.
          </h1>
          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-body">
            Cleaning that gives you time back should never cost you time to arrange. Here is the whole journey.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {JOURNEY_STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06}>
              <div className="h-full rounded-3xl border border-subtle bg-surface p-8 transition-all duration-300 hover:shadow-xl hover:border-sage">
                <span className="font-serif text-5xl text-sage/70">{s.n}</span>
                <h2 className="mt-5 font-sans text-lg font-semibold text-blue">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-body">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-blue-midnight text-canvas">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 py-24 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-5xl tracking-tight">Not sure which service you need?</h2>
            <p className="mx-auto mt-5 max-w-lg text-canvas/75">
              Tell us what you need and we can help you choose.
            </p>
            <div className="mt-9 flex flex-wrap justify-center gap-4">
              <Link
                to="/contact"
                data-testid="hiw-contact-button"
                className="inline-flex items-center gap-2 rounded-full bg-canvas px-8 py-4 font-mono text-xs uppercase tracking-[0.18em] text-blue transition-all duration-300 hover:-translate-y-0.5"
              >
                Get in Touch <ArrowUpRight size={15} />
              </Link>
              <Link
                to="/book"
                data-testid="hiw-book-button"
                className="inline-flex items-center gap-2 rounded-full border border-canvas/30 px-8 py-4 font-mono text-xs uppercase tracking-[0.18em] text-canvas transition-all duration-300 hover:border-canvas hover:-translate-y-0.5"
              >
                Book a Clean
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
